import React from 'react';
import { EMPTY_IMAGE_PLACEHOLDER } from '../const/system';



const getPushNotificationOptions = (pushNotifications = []) => {
  return pushNotifications.map((item) => {
    return {
      label: (
        <div className="hp-d-flex hp-align-items-center">
          <img height={20} src={item?.preview ?? EMPTY_IMAGE_PLACEHOLDER} alt="preview img" />
          <span className="hp-ml-4">{item.title}</span>
        </div>
      ),
      title: item.title,
      value: item.id,
    };
  });
};

export default getPushNotificationOptions;
